import { createContext, useContext, Dispatch, SetStateAction } from 'react';
import { EnvironmentType } from 'features/utils/api/models/Environment'; // Adjust path if necessary
import { UtilCategory } from '../api/models/Category';

export interface FilterContextType {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  environmentTypeFilter: EnvironmentType | null;
  setEnvironmentTypeFilter: Dispatch<SetStateAction<EnvironmentType | null>>;
  categoryFilter: UtilCategory | null;
  setCategoryFilter: Dispatch<SetStateAction<UtilCategory | null>>;
}

export const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const useFilters = (): FilterContextType => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilters must be used within a FilterProvider');
  }
  return context;
};
